import React, { useEffect, useState, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import { useHistory, useParams, useRouteMatch } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { CalculatecompletedPercentage } from "../../../Utils/CalculateCompletion";

function Deleteresume(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const calculatedData = CalculatecompletedPercentage(
    props && props.resumeFields
  );
  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const handleAddSection = (section) => {
    props.setSection(section, props.sectionType);
    const element = document.getElementsByClassName(`basic-scroll-${section}`);
    setTimeout(() => {
      if (element && element[0]) {
        element[0].scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
      }
    }, 350);
  };

  const handleScrollSection = (section) => {
    const element = document.getElementsByClassName(`basic-scroll-${section}`);
    setTimeout(() => {
      if (element && element[0]) {
        element[0].scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });
      }
    }, 350);
  };
  return (
    <>
      <Modal
        show={props.show}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <img
            onClick={props.hide}
            src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/close.svg`}
            alt="closeicon"
            className="close"
          />
          <div className="container">
            <div className="text-center">
              {/* <img src="/images/pro_img.png" /> */}
              <h4
                className="maintitle deletetitle"
                style={{ fontWeight: "500" }}
              >
                Missing Sections !
              </h4>
              <p className="titledesc m-0 mb-2" style={{ fontSize: "18px" }}>
                To boost your resume score, kindly provide the missing
                information for enhanced effectiveness.
              </p>
            </div>
            <div>
              <p className="m-0 mb-1" style={{ fontSize: "17px" }}>
                Missing Fields:
              </p>
              <div className="row">
                {calculatedData &&
                  calculatedData.missingFields &&
                  calculatedData.missingFields.map((resp, index) => (
                    <>
                      <div className="col-md-3">
                        <p className="m-0 mb-2" style={{ fontSize: "15px" }}>
                          {capitalize(resp?.section)}:
                        </p>
                        {resp &&
                          resp.fields &&
                          resp.fields.map((res) => (
                            <p
                              className="m-0 mb-1"
                              style={{ fontSize: "13px", cursor: "pointer" }}
                              onClick={() => handleScrollSection(resp.section)}
                            >
                              {capitalize(res && res)}
                            </p>
                          ))}
                      </div>
                    </>
                  ))}
              </div>
            </div>
            <div>
              {calculatedData &&
                calculatedData.missingSections &&
                calculatedData.missingSections.length > 0 && (
                  <p className="m-0 mb-1 mt-2" style={{ fontSize: "17px" }}>
                    Missing Sections:
                  </p>
                )}
              <div className="row">
                {calculatedData &&
                  calculatedData.missingSections &&
                  calculatedData.missingSections.map((resp, index) => (
                    <>
                      <div className="col-md-3">
                        <p
                          onClick={() => handleAddSection(resp?.section)}
                          style={{ cursor: "pointer", fontSize: "15px" }}
                        >
                          {capitalize(resp?.section)}
                        </p>
                      </div>
                    </>
                  ))}
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <button
                  onClick={props.showPreview}
                  className="btn primarybtn  bgsuccess text-white mainborder float-right   p-14 w-75 delbtn"
                >
                  Continue
                </button>
              </div>
              <div className="col-md-6">
                <button
                  onClick={props.hide}
                  className="btn primarybtn  w-75 mainborder delbtn position-relative"
                >
                  <span className="resume-options">Edit</span>
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default Deleteresume;
